"use strict";

import Dom from "common/Dom";
import * as handlers from "components/Overlay/handlers.js";
export const openProductModal = function openProductModal($this) {
  var modalIndex = parseInt($this.attr("data-index"));
  var imgSrc = window.imageArray[modalIndex];
  $(Dom.intModal).addClass("is-active");
  $(Dom.intModalImg).attr("src", imgSrc);
  handlers.showOverlay();
};
export const closeProductModal = function closeProductModal($this) {
  $(Dom.intModal).removeClass("is-active");
};
export const validateUser = function validateUser($form) {
  var inputVal = $(Dom.intPasswordInput).val();
  if (inputVal === window.internationalLoginPassword) {
    sessionStorage.setItem("intValidated", true);
    return (window.location.href = "/pages/international-english");
  }
  return $(Dom.intFormError).addClass("is-active");
};
export const checkCookie = function checkCookie(cookie) {
  if (window.sessionStorage.getItem(cookie) === "true") {
    $(Dom.intLanding).addClass("is-visible");
  } else {
    window.location.href = "/pages/international-login";
  }
};
